import { useChangeSearch, useSearch } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import SearchInput from '../../../components/form/SearchInput'
import Separator from '../../../components/helpers/Separator'

const ControlBar = () => {
  const { t } = useTranslation()

  const changeSearch = useChangeSearch()
  const search = useSearch()

  return (
    <Fragment>
      <Separator weight={4} />
      <FlexGrid justify="space-between" gutter={0.4}>
        <FlexCol></FlexCol>

        <FlexCol></FlexCol>

        <FlexCol flex={3} />
        <FlexCol flex={1}>
          <SearchInput value={search} onStopTyping={changeSearch} />
        </FlexCol>
      </FlexGrid>
      <Separator weight={4} />
    </Fragment>
  )
}

export default ControlBar
